const supportedSensorDisplayDatapoints = [
  {
    id: "temperature",
    name: "Temperature",
  },
  {
    id: "probe_temp",
    name: "Probe Temperature",
  },
  {
    id: "humidity",
    name: "Humidity",
  },
  {
    id: "heat_index",
    name: "Heat Index",
  },
  {
    id: "dew_point",
    name: "Dew Point",
  },
  {
    id: "battery",
    name: "Battery",
  },
  {
    id: "power",
    name: "USB Power",
  },
  {
    id: "rssi",
    name: "Connection Quality (RSSI)",
  },
];

export default supportedSensorDisplayDatapoints;
